module.exports = __webpack_public_path__ + "static/radiotron-poster-426ed53f404902bb46fe72c3806e0524.jpg";